export default class SelectGoogleAccount {
    constructor() {
        return {
            template: require('../../../../views/segment/modal/select-google-account.html'),
            replace: true,
            restrict: 'E',
            scope: {
                columns: '='
            },
            controller: SelectGoogleAccountCtrl,
            controllerAs: 'google'
        }
    }
};

class SelectGoogleAccountCtrl {
    constructor($scope) {
        this._scope = $scope;

        this._scope.$on('segment:show:selectGoogleAccount', (event, accounts) => {
            this.accounts = accounts;
            this.accountId = accounts[0].id;
            this.toggleShow();
        });

        $(document).keyup((e) => {
            if (e.keyCode == 27) {
                this.toggleShow();
                this._scope.$apply(); // Close modal on escape.
            }
        });
    }

    toggleShow() {
        this.show = !this.show;
    }

    save() {
        this._scope.$emit('segment:uploadSubscribersToGoogle', this.accountId);
        this.toggleShow();
    }
}